// src/app/shared/services/notification.service.ts
import { Injectable, inject } from '@angular/core';
import { AlertController, ToastController, AlertButton } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private toastController = inject(ToastController);
  private alertController = inject(AlertController);

  async presentToast(
    message: string,
    color: string = 'primary',
    position: 'bottom' | 'middle' | 'top' = 'bottom'
  ){
    const toast = await this.toastController.create({
      message,
      color,
      position,
      duration: 2000
    });
    await toast.present();
  }

  // Tipo compatível com Ionic AlertButton.handler
  private normalizeHandler(
    handler?: AlertButton['handler']
  ): ((value: unknown) => boolean | void | Record<string, unknown> | Promise<boolean | void | Record<string, unknown>>) | undefined {
    if (!handler) return undefined;

    return (value: unknown) => {
      const result = handler(value);
      // Garante fechamento do alert
      if (result === undefined || result === null) {
        return true;
      }
      return result;
    };
  }

  async presentAlert(options: {
    header?: string;
    message: string;
    buttons: (string | AlertButton)[];
    cssClass?: string;
    backdropDismiss?: boolean;
  }): Promise<boolean> {
    const alert = await this.alertController.create({
      header: options.header,
      message: options.message,
      mode: 'md',
      cssClass: ['custom-alert', options.cssClass].filter(Boolean).join(' '),
      backdropDismiss: options.backdropDismiss ?? true,
      buttons: this.formatButtons(options.buttons),
    });

    await alert.present();
    const { role } = await alert.onDidDismiss();
    return role !== 'cancel' && role !== 'backdrop';
  }

  // MÉTODO AUXILIAR: FORMATA BOTÕES COM ESTILO PADRÃO
  private formatButtons(buttons: (string | AlertButton)[]): AlertButton[] {
    return buttons.map(btn => {
      if (typeof btn === 'string') {
        return {
          text: btn,
          role: btn.toLowerCase() === 'cancel' ? 'cancel' : undefined,
          cssClass: 'alert-button' // ← Usa a classe estilizada no CSS global
        };
      }
      return {
        ...btn,
        // 🔧 NORMALIZA O HANDLER PARA GARANTIR FECHAMENTO CONSISTENTE
        handler: this.normalizeHandler(btn.handler),
        cssClass: ['alert-button', btn.cssClass].filter(Boolean).join(' ')
      };
    });
  }
}
